import { splitIntoChunks } from "../utils/textUtils";

export const useTTS = () => {
  const speak = (text) => {
    if (!text) return;
    const chunks = splitIntoChunks(text);

    const voices = speechSynthesis.getVoices();
    const voice = voices.find(
      (voice) => voice.name === "Google UK English Male"
    );

    speechSynthesis.cancel();

    chunks.forEach((chunk) => {
      const utterance = new SpeechSynthesisUtterance(chunk);
      utterance.voice = voice;
      utterance.lang = "en-US";
      utterance.rate = 0.9;
      utterance.pitch = 1;
      speechSynthesis.speak(utterance);
    });
  };

  const stopSpeaking = () => {
    speechSynthesis.cancel();
  };

  return { speak, stopSpeaking };
};
